export enum ImageFolderEnum {
    OPERATORS = 'operators',
    MEDIA = 'media',
    LICENSES = 'licenses'
}

export type FolderType =`${ImageFolderEnum}`; 